<template>
	<div class="container">
		<div class="containerTop">
			<a-button type="primary" @click="transfer" :disabled="selectedRowKeys.length == 0"> 移交 </a-button>
			<a-button type="primary" @click="setInventory" :disabled="selectedRowKeys.length == 0"> 设为库存 </a-button>
		</div>
		<div class="content_main_top">
			<a-select show-search allowClear placeholder="公司名称" class="margin_self" @change="handlecompany"
				v-model="quaryData.company_id" @keyup.enter.native="query" style="width: 170px">
				<a-select-option :value="item.deptId" v-for="(item, index) in companyList" :key="index">
					{{ item.title }}
				</a-select-option>
			</a-select>
			<a-tree-select allowClear :treeData="deptTree2" placeholder="部门名称" class="margin_self"
				@keyup.enter.native="serch" v-model="quaryData.dept_id" :disabled="!quaryData.company_id"
				style="width: 170px" treeDefaultExpandAll>
			</a-tree-select>
			<a-input v-model="quaryData.category_name" allowClear class="a_input_self margin_self" placeholder="品类名称"
				style="width: 170px" @keyup.enter.native="serch" />
			<a-input v-model="quaryData.asset_sn" allowClear class="a_input_self margin_self" placeholder="物品编号"
				style="width: 170px" @keyup.enter.native="serch" />
			<a-input v-model="quaryData.name" allowClear class="a_input_self margin_self" placeholder="物品名称"
				style="width: 170px" @keyup.enter.native="serch" />
			<!-- <a-input v-model="quaryData.state" allowClear class="a_input_self margin_self" placeholder="物品状态" style="width: 170px"
				@keyup.enter.native="serch" /> -->
			<a-select show-search allowClear placeholder="物品状态" class="margin_self" v-model="quaryData.state"
				style="width: 170px" @keyup.enter.native="serch">
				<a-select-option :value="index" v-for="(item, index) in statusMap6" :key="index">
					{{ item }}
				</a-select-option>
			</a-select>
			<a-input v-model="quaryData.keeper" allowClear class="margin_self" placeholder="保管人" style="width: 170px"
				@keyup.enter.native="serch" />
			<a-button type="primary" style="margin: 5px" @click="serch" @keyup.enter.native="serch"> 查询 </a-button>
			<a-button type="primary" ghost @click="reset"> 清空 </a-button>
		</div>
		<div class="content_main_center" id="content_main_center_scroll" >
			<a-table :columns="columns" :data-source="dataList" :pagination="pagination" @change="handleTableChange"
				:row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" bordered
				:scroll="{ x: 1500, y: scroll_y }">
				<span slot="index" slot-scope="text, record, index">
					{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
				</span>
				<span slot="asset_type" slot-scope="text">
					{{ text? goodsTypeObj[text]: '' }}
				</span>
				<span slot="state" slot-scope="text">
					<template>
						<a-tag :color="colors[text]">
							{{ text? statusMap6[text]: '' }}
						</a-tag>
					</template>
				</span>
				<span slot="is_inspected" slot-scope="text">
					{{ instrumentMap[text] }}
				</span>
				<span slot="is_labelled" slot-scope="text" :style="{ color: text == 1 ? '#1890ff' : 'red' }">
					{{ text == 1 ? '已打印标签' : '未打印标签' }}
				</span>
				<span slot="img" slot-scope="text, record" :style="{ color: record.pic_path ? 'green' : 'red' }">
					{{ record.pic_path ? '已上传图片' : '未上传图片' }}
				</span>
				<span slot="action" slot-scope="text, record">
					<a @click="details(record)">详情</a>
				</span>
			</a-table>
		</div>
		<TransferModel ref="transferModel" @refresh="refresh"></TransferModel>
		<FixedAssetsDetail ref="fixedAssetsDetail"></FixedAssetsDetail>
	</div>
</template>

<script>
import TransferModel from './component/transferModel.vue'
import FixedAssetsDetail from './component/fixedAssetsDetail.vue'
import { tree_all } from '@/api/purchase'
import { statusMap } from '@/api/activiti'
import { instrumentMap } from '@/utils/const'
import {
	daily_list,
	getTransferList
} from '@/api/assetmenag'
const columns = [{
	title: '序号',
	dataIndex: 'index',
	key: 'index',
	scopedSlots: {
		customRender: 'index',
	},
	width: 70,
	ellipsis: true,
},
{
	title: '所属公司',
	dataIndex: 'company_name',
	key: 'company_name',
	width: 120,
	ellipsis: true,
},
{
	title: '所属部门',
	dataIndex: 'dept_name',
	key: 'dept_name',
	width: 120,
	ellipsis: true,
},
{
	title: '资产类别',
	dataIndex: 'asset_type',
	key: 'asset_type',
	scopedSlots: {
		customRender: 'asset_type',
	},
	width: 120,
	ellipsis: true,
},
{
	title: '品类名称',
	dataIndex: 'category_name',
	key: 'category_name',
	width: 150,
	ellipsis: true,
},
{
	title: '物品编号',
	dataIndex: 'asset_sn',
	key: 'asset_sn',
	width: 150,
	ellipsis: true,
},
{
	title: '物品名称',
	dataIndex: 'name',
	key: 'name',
	width: 150,
	ellipsis: true,
},
{
	title: '规格型号',
	dataIndex: 'model',
	key: 'model',
	width: 300,
	ellipsis: true,
},
{
	title: '物品单位',
	dataIndex: 'unit',
	key: 'unit',
	width: 150,
	ellipsis: true,
},
{
	title: '物品状态',
	dataIndex: 'state',
	key: 'state',
	scopedSlots: {
		customRender: 'state',
	},
	width: 150,
	ellipsis: true,
},
{
	title: '是否检定',
	dataIndex: 'is_inspected',
	key: 'is_inspected',
	scopedSlots: {
		customRender: 'is_inspected',
	},
	width: 150,
	ellipsis: true,
},
{
	title: '准用说明',
	dataIndex: 'permit',
	key: 'permit',
	width: 150,
	ellipsis: true,
},
{
	title: '责任人',
	dataIndex: 'charger',
	key: 'charger',
	width: 150,
	ellipsis: true,
},
{
	title: '保管人',
	dataIndex: 'keeper',
	key: 'keeper',
	width: 150,
	ellipsis: true,
},
{
	title: '供应商',
	dataIndex: 'dealer',
	key: 'dealer',
	width: 150,
	ellipsis: true,
},
{
	title: '当前估值',
	dataIndex: 'value',
	key: 'value',
	width: 150,
	ellipsis: true,
},
{
	title: '采购单价',
	dataIndex: 'purchase_price',
	key: 'purchase_price',
	width: 150,
	ellipsis: true,
},
{
	title: '采购时间',
	dataIndex: 'purchase_time',
	key: 'purchase_time',
	width: 150,
	ellipsis: true,
},
{
	title: '备注',
	dataIndex: 'notes',
	key: 'notes',
	width: 150,
	ellipsis: true,
},
{
	title: '录入人',
	dataIndex: 'create_by',
	key: 'create_by',
	width: 150,
	ellipsis: true,
},
{
	title: '录入时间',
	dataIndex: 'create_time',
	key: 'create_time',
	width: 200,
	ellipsis: true,
},
{
	title: '维护人',
	dataIndex: 'update_by',
	key: 'update_by',
	width: 150,
	ellipsis: true,
},
{
	title: '维护时间',
	dataIndex: 'update_time',
	key: 'update_time',
	width: 200,
	ellipsis: true,
},
{
	title: '标签打印',
	dataIndex: 'is_labelled',
	key: 'is_labelled',
	width: 150,
	scopedSlots: {
		customRender: 'is_labelled',
	},
	ellipsis: true,
},
{
	title: '物品图片',
	dataIndex: 'img',
	width: 150,
	key: 'img',
	scopedSlots: {
		customRender: 'img',
	},
},
{
	title: '操作',
	key: 'action',
	scopedSlots: {
		customRender: 'action',
	},
	fixed: 'right',
	width: 150,
},
]
export default {
	components: {
		TransferModel,
		FixedAssetsDetail

	},
	data() {
		return {
			typeIndex: undefined,
			companyList: [],
			deptTree2: [],
			quaryData: {
				state: undefined,
				company_id: undefined,
				dept_id: undefined,
				asset_sn: '',
				name: '',
				keeper: '',
				category_name: ''

			},
			statusMap,
			// instrumentMap,
			instrumentMap: {
				'0': '否',
				'1': '是',
			},
			columns,
			dataList: [],
			scroll_y: 1500,
			selectedRowKeys: [],
			selectedRows: [],
			pagination: {
				current: 1,
				pageSize: 10,
				total: 0,
				pageSizeOptions: ['10', '20', '30', '40', '50'],
				showLessItems: true,
				showSizeChanger: true,
			},
		}
	},
	created() {
		this.get_lis()
		this.getcompanyList()

	},
	mounted() {
		this.$nextTick(() => {
			var max_h = $('#content_main_center_scroll').height()
			console.log(max_h, 'sssssssss')
			setTimeout(() => {
				console.log($('.ant-table-header').height(), 'aaaaaaaaaaaaa')
				this.scroll_y = max_h - $('.ant-table-header').height() -40
			}, 1000)
		})
	},
	methods: {
		//详情 fixedAssetsDetail
		details(record) {
			this.$refs.fixedAssetsDetail.init(record)
		},
		//
		refresh() {
			this.selectedRows = []
			this.selectedRowKeys = []
			this.get_lis()

		},
		//改变分页
		handleTableChange(pagination) {
			this.pagination.current = pagination.current
			this.pagination.pageSize = pagination.pageSize
			// this.loading = true
			this.get_lis()
		},
		//设为库存
		setInventory() {
			this.typeIndex = 1
			this.$refs.transferModel.init({
				selectedRows: this.selectedRows,
				typeIndex: this.typeIndex
			})

		},
		//移交transferModel
		transfer() {
			this.typeIndex = 0
			this.$refs.transferModel.init({
				selectedRows: this.selectedRows,
				typeIndex: this.typeIndex
			})

		},
		//重置
		reset() {
			this.quaryData.state = undefined
			this.quaryData.company_id = undefined
			this.quaryData.dept_id = undefined
			this.quaryData.name = ''
			this.quaryData.keeper = ''
			this.quaryData.asset_sn = ''
			this.pagination.current = 1
			this.quaryData.category_name = ''

		},
		//查询
		serch() {
			this.pagination.current = 1
			this.get_lis()
		},
		//选择部门
		handlecompany(e) {
			this.quaryData.dept_id = ''
			this.companyList.forEach(item => {
				if (item.deptId == e) {
					this.deptTree2 = item.children
				}
			})

		},
		//获取公司
		getcompanyList() {
			tree_all().then(res => {
				this.companyList = res.data[0]
			})
		},
		// 多选
		onSelectChange(selectedRowKeys, selectedRows) {

			this.selectedRowKeys = selectedRowKeys
			this.selectedRows = selectedRows
			console.log(this.selectedRows, 'this.selectedRows=================')
		},

		// 获取列表
		get_lis() {
			// daily_list
			getTransferList({
				pageSize: this.pagination.pageSize,
				pageNum: this.pagination.current,
				name: this.quaryData.name,
				asset_sn: this.quaryData.asset_sn,
				dept_id: this.quaryData.dept_id,
				company_id: this.quaryData.company_id,
				keeper: this.quaryData.keeper,
				category_name: this.quaryData.category_name,
				state: this.quaryData.state

			}).then((res) => {
				res.rows.forEach(item => {
					if (item.purchase_time) {
						if (item.purchase_time.indexOf(" ") != -1) {
							item.purchase_time = item.purchase_time.split(' ')[0]
						}
					}
				})
				this.pagination.total = res.total
				this.dataList = res.rows
				console.log(this.dataList, 'dataList=========')
				// this.dataList.forEach((item) => {
				// 	item.purchase_price = item.purchase_price / 100
				// 	item.value = item.value / 100
				// 	item.amount = item.amount / 100
				// })
			})
		},
	}

}
</script>

<style scoped>
.container{
	width: 100%;
	height: 100%;
	float: left;
}
</style>